<template>
    <div style="background: #f1f2f6;">
        <div class="containerb" style="margin: 0px auto;">
            <div style="width: 1200px;overflow-x: auto;" class="scroll-container" id="scrollcontainer">
                <div
                    style="display: flex;align-items: center;padding-top: 20px;width: 1500px;justify-content: space-between;">
                    <div @click="getInfo(w, j)"
                        :class="[{ 'mindex': w.title == mindex }, { 'menu': mindex != w.title }]"
                        style="margin: 10px 0px; padding:5px 20px;cursor: pointer;border-radius: 30px;font-size: 14px;color:#999999"
                        v-for="(w, j) in menu">{{
                            w.title }}
                    </div>
                </div>
            </div>

            <div style="margin-top: 5px;font-size: 14px;margin-left: 20px;">
                {{ data.text }}
            </div>

            <div style="background: #fff;display: flex;align-items: center;padding:5px 5px;margin-top: 20px;">
                <div style="position: relative;width: 80px;height: 36px;">
                    <img style="" src="../../assets/AI/bq.png" />
                    <div style="position: absolute;top: 6px;color: #fff;left: 11px;font-size: 14px;">应用详情</div>
                </div>
                <div style="font-size: 14px;margin-left: 10px;width: 1090px;">{{ data.info }}</div>
            </div>

            <div style="background: #fff;margin-top: 20px;padding-top: 50px;">
                <div style="font-size: 28px;text-align: center;">
                    痛点与解决方案
                </div>
                <div style="margin-top: 20px;">
                    <img style="margin: 0px auto;" :src="data.img" />
                </div>
            </div>

            <div style="background: #fff;padding-top: 50px;">
                <div style="font-size: 28px;text-align: center;">核心功能</div>
                <div
                    style="display: flex;align-items: center;justify-content: space-between;padding:0px 35px;margin-top: 50px;">
                    <div v-for="x in data.hxgn" style="width: 265px;"
                        :style="{ 'width': data.hxgn.length === 4 ? '265px' : '208px' }">
                        <div style="text-align: center;font-size: 14px;color: #fff;height: 30px;line-height: 30px; background-size: 100;width: 180px;margin: 0px auto;"
                            :style="{ backgroundImage: 'url(' + require('@/assets/AI/btk.png') + ')' }">
                            {{ x.title }}
                        </div>
                        <div
                            style="height: 210px;width: 100%;font-size: 14px;background: #f6fafd;padding: 20px;border-radius: 10px;line-height: 23px;">
                            {{ x.text }}
                        </div>
                    </div>
                </div>
            </div>

            <div style="background: #fff;padding-top: 50px;">
                <div style="padding: 38px;font-size: 28px;margin-left: 5px;text-align: center;">典型应用场景</div>
                <div class="file flex-container"
                    style="flex-wrap: wrap;justify-content: space-between;align-items: center;padding:0px 35px;">
                    <div style="padding:28px 30px 28px 0px;" v-for="x in data.card" class="cardx">
                        <div class="file">
                            <div v-show="x.title" style="height: 60px;margin-top: 6px;border-left: 3px solid #1e66d1;"
                                class="bprimary">
                            </div>
                            <div style="margin-left: 22px;width: 280px;">
                                <div style="font-size: 18px;color: #1e66d1;" class="cprimary">{{ x.title }}
                                </div>
                                <div class="ftext" style="margin-top: 10px;line-height: 26px;">{{
                                    x.text
                                }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="background: #fff;padding-top: 50px;padding-bottom: 50px;">
                <div style="font-size: 28px;text-align: center;">核心价值</div>
                <div style="height:280px;display: flex;align-items: center;justify-content:space-around;margin:0px 35px;margin-top: 50px;background-size: cover;"
                    :style="{ backgroundImage: 'url(' + require('@/assets/AI/hxjz.jpg') + ')' }">
                    <div v-for="x in data.hxjz">
                        <div
                            style="text-align: center;font-size: 18px;font-weight: bold; color:#1e66d1;margin: 0px auto;">
                            <div>{{ x.title }}{{ x.titleb }}</div>
                        </div>
                        <div style="background: #1e66d1;border-radius: 10px;"
                            :style="{ 'width': data.hxjz.length == 4 ? '242px' : '196px' }">
                            <div
                                style="margin-top: 15px; height: 170px;font-size: 14px;background: #f6fafd;padding: 20px;border-radius: 10px;line-height: 23px;color: #000;position: relative;top: 5px;">
                                {{ x.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="background: #fff;padding-top: 50px;padding-bottom: 50px;">
                <div style="font-size: 28px;text-align: center;">功能展示</div>
                <div
                    style="margin: 35px;border: 1px dashed #1e66d1;border-radius: 10px;padding: 0px 15px;padding-top: 30px;">
                    <div v-for="x in data.gnzs" style="margin: 0px 15px;margin-bottom: 35px;">
                        <img :src="x" style="margin: 0px auto;max-width: 1050px;">
                    </div>
                    <div style="display: flex;align-items: end;justify-content: center;width: 100%;flex-wrap: wrap;">
                        <div v-for="x in data.gnzsb" style="margin: 0px 15px; margin-bottom: 35px;"
                            :style="{ 'width': x.width }">
                            <div><img :src="x.img" style="box-shadow: #e5eff6 -1px 8px 10px 0px;"></div>
                            <div v-show="x.title"
                                style="height: 32px;line-height: 32px;font-size: 14px;text-align: center;background: #ececec;margin: 0px auto;margin-top: 20px;border-radius: 20px;padding: 0px 20px;display: table;">
                                {{ x.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getJsonTree } from '@/utils/index'
var isMouseDown = false;
var ul = null;
export default {
    data() {
        return {
            action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
            index: 0,
            mindex: '',
            menu: [
                {
                    title: '企业小龙虾',
                    text: 'OpenClaw开源框架 + 多智能体协同，打造企业级数据智能中台',
                    info: '基于OpenClaw开源AI智能体框架，构建企业专属的“数据智能军团”。与个人版“小龙虾”不同，企业小龙虾聚焦数据采集、清洗、分析与报告生成全流程自动化，通过多智能体协同，将分散在内部系统、公开渠道的异构数据转化为可执行的业务洞察，让数据资产真正“活起来”。',
                    img: require('@/assets/AI/小龙虾.jpg'),
                    hxgn: [
                        {
                            title: '智能数据采集Agent',
                            text: '基于OpenClaw Scout模块，支持自动抓取企业内部数据库、API、Excel/PDF文档，以及公开网页、社交媒体、竞品官网等渠道数据。可自定义采集规则（定时、事件触发），自动识别新增数据并增量同步，彻底告别手动导出导入。'
                        },
                        {
                            title: '多智能体协同分析',
                            text: '借鉴“Manager/Worker”多智能体架构 ：Manager Agent负责拆解复杂分析任务，分配至专业Worker（如数据清洗Agent、关联分析Agent、异常检测Agent）并行执行。各Agent独立运行、隔离内存，避免上下文污染，确保分析精准高效。'
                        },
                        {
                            title: '自动报告生成',
                            text: '分析结果自动输入报告生成Agent，基于预设模板（日报/周报/专题报告）一键生成结构化文档，包含数据图表、趋势分析、结论建议。支持PDF/Word/Excel多格式导出，可同步推送至企业微信、飞书、钉钉。'
                        },
                        {
                            title: '私有化安全部署',
                            text: '支持完全私有化部署，所有数据留存企业内部。内置企业级安全增强套件，实现细粒度权限管控、操作审计、插件沙箱隔离。可对接企业现有IAM系统，确保数据合规与安全。'
                        }
                    ],
                    card: [
                        {
                            title: '市场竞品监测',
                            text: '自动采集竞品官网、行业论坛、社交媒体信息，实时监测价格变动、新品发布、舆情动态，生成竞品周报，辅助市场策略制定。',
                        },
                        {
                            title: '供应链风险预警',
                            text: '整合采购数据、物流信息、供应商新闻，构建供应链风险热力图，发现交货延迟、原材料涨价等苗头，自动触发预警并推送替代方案建议。',
                        },
                        {
                            title: '财务数据分析',
                            text: '自动从ERP、财务系统采集数据，生成月度经营分析报告，涵盖收入/成本趋势、预算执行率、异常波动归因分析，财务人员从“做表”转向“看数”。',
                        },
                        {
                            title: '客户之声洞察',
                            text: '基于企业微信会话存档，分析客户投诉、咨询、反馈中的高频问题和情绪趋势，生成服务质量报告，推动产品和服务优化。',
                        },
                        {
                            title: '研发知识沉淀',
                            text: '自动抓取散落在Confluence、GitLab、邮件中的技术文档、代码注释、会议纪要，构建研发知识图谱，支持自然语言检索，减少重复造轮子。',
                        },
                        {
                            title: '销售商机挖掘',
                            text: '分析销售聊天记录中的购买信号（比价、扩容、竞品对比），自动标记高意向客户，生成客户画像和跟进建议，推送至销售主管。',
                        },
                        {
                            title: '合规审计辅助',
                            text: '自动扫描合同、邮件、聊天记录中的合规风险（如敏感词、违规承诺），生成审计报告，标注风险点及处置建议，满足监管要求。',
                        },
                        {
                            title: '运营数据看板',
                            text: '整合多业务系统数据，自动生成运营日报/周报，包含核心指标趋势、异常波动预警，管理层可一键查看，告别手动汇总。',
                        },
                        {
                            title: '',
                            text: '',
                        }
                    ],
                    hxjz: [
                        {
                            title: '效率跃升，一人抵一队',
                            titleb: '',
                            text: '数据采集、清洗、分析、报告全流程自动化，将分析师从重复劳动中解放，复杂分析任务从“天”级缩短至“分钟”级。'
                        },
                        {
                            title: '多智能体协同，专业分工',
                            titleb: '',
                            text: 'Manager/Worker架构确保任务拆解清晰、专业Agent专注执行，避免“全能Agent”的记忆臃肿和逻辑冲突，分析质量更高。'
                        }, {
                            title: '私有化部署，安全合规',
                            titleb: '',
                            text: '数据不出域，权限可控，满足金融、政务等高敏行业监管要求；开源框架+企业级安全增强，无厂商锁定风险。'
                        }, {
                            title: '持续沉淀，越用越聪明',
                            titleb: '',
                            text: '分析模板、报告格式、采集规则可复用、可优化，企业数据资产持续积累，分析能力随业务进化而提升。'
                        }, {
                            title: '无缝集成，即装即用',
                            titleb: '',
                            text: '与企业微信、飞书、钉钉深度集成，分析结果可自动推送至工作群；支持API对接现有BI、数据中台，快速嵌入现有流程。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs25.png'),
                        require('@/assets/AI/gnzs26.png')
                    ]
                },
                {
                    title: 'AI舆情监测',
                    text: '企业微信会话存档 + AI语义理解，让内部沟通风险无处遁形',
                    info: '基于AI大模型深度分析企业微信聊天内容，精准识别敏感信息泄露与舆情风险，变被动处置为主动预警，帮助企业筑牢信息安全防线。',
                    img: require('@/assets/AI/cp-ai-2.jpg'),
                    hxgn: [
                        {
                            title: '智能语义理解',
                            text: '基于AI大模型，对企业微信聊天内容进行深度语义分析，准确识别用户真实意图。当触发预设关键词时，系统自动判断是正常讨论、情绪宣泄、恶意投诉还是敏感信息泄露，大幅降低误报率。'
                        },
                        {
                            title: '敏感信息监测',
                            text: '自定义设置敏感词库（如产品配方、实验数据、未公开财报等），AI实时扫描群聊与单聊内容，结合上下文判断是否存在潜在泄露风险，一旦发现异常立即预警，防止内部信息外泄。'
                        },
                        {
                            title: '实时预警推送',
                            text: '识别到舆情风险或敏感行为后，系统通过企业微信实时推送预警至指定管理人员，包含风险类型、触发内容、上下文截图及处置建议，支持分级通知，确保快速响应。'
                        },
                        {
                            title: '分析记录与追溯',
                            text: '所有风险事件的分析记录自动归档，管理后台可随时查阅历史记录、处置进度和趋势分析。支持多维度筛选与导出，为内部合规审计和安全策略优化提供数据支撑。'
                        }
                    ],
                    card: [
                        {
                            title: '客户投诉预警',
                            text: '实时识别聊天中的投诉、抱怨等负面情绪，及时介入处理，防止客诉升级。',
                        },
                        {
                            title: '员工情绪监测',
                            text: '监测员工对企业政策、管理的不满情绪，提前发现团队不稳定因素，辅助管理决策。',
                        },
                        {
                            title: '敏感词防泄露',
                            text: '监测产品配方、实验数据、客户信息等敏感词泄露，防范商业机密外流。',
                        },
                        {
                            title: '竞品讨论监控',
                            text: '识别员工在群聊中讨论竞品、跳槽意向等行为，及时发现潜在人才流失风险。',
                        },
                        {
                            title: '内部风险行为识别',
                            text: '监测私单、飞单、私加客户等违规行为，结合上下文分析意图，降低经营风险。',
                        },
                        {
                            title: '合规审计辅助',
                            text: '自动留存风险分析记录，满足合规审计要求，支持导出报告供内部审查。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '主动预防',
                            titleb: '风险前置',
                            text: '从被动抽查到全量实时监测，将舆情风险消灭在萌芽状态。'
                        },
                        {
                            title: '精准识别',
                            titleb: '降低误报',
                            text: '大模型语义理解取代关键词机械匹配，准确区分调侃、引用与真实投诉。'
                        }, {
                            title: '防患未然',
                            titleb: '保障机密',
                            text: '实时监测敏感信息泄露，守护企业核心资产安全。'
                        }, {
                            title: '数据驱动',
                            titleb: '管理有据',
                            text: '沉淀风险分析数据，生成趋势报告，为内部管理优化提供依据。'
                        }, {
                            title: '轻量集成',
                            titleb: '快速部署',
                            text: '与企业微信无缝对接，无需改变员工使用习惯，即装即用。'
                        }
                    ],
                    // gnzs: [
                    //     require('@/assets/AI/gnzs4.png'),
                    //     require('@/assets/AI/gnzs5.png'),
                    // ],
                    gnzsb: [
                        {
                            title: 'AI聊天预警',
                            img: require('@/assets/AI/图层 73.png'),
                            width: '32%',
                        }, {
                            title: '群聊内容监测',
                            img: require('@/assets/AI/群聊内容监测.png'),
                            width: '50%',
                        }, {
                            title: '智能业务流程',
                            img: require('@/assets/AI/图层 77.png'),
                            width: '85%',
                        }
                    ]
                },
                {
                    title: '智慧财务服务助手',
                    text: '自然语言交互+流程自动化，打造全员畅享的智能财务体验',
                    info: '整合财务咨询、进度查询、催办通知等高频场景，让员工随时问、随时查，让财务人员高效管、轻松催，全面提升财务服务效率与透明度。',
                    img: require('@/assets/AI/cp-ai-3.jpg'),
                    hxgn: [
                        {
                            title: '智能财务问答',
                            text: '基于财务知识库，支持自然语言提问（如“报销标准”“公积金提取流程”），准确解答员工常见问题，减少财务重复咨询，提升响应速度。'
                        },
                        {
                            title: '流程进度查询',
                            text: '员工可随时查看自己提交的报销、付款、借款等申请进度，实时了解当前节点和预计完成时间，流程透明可控，告别焦虑等待。'
                        },
                        {
                            title: '智能催办与通知',
                            text: '系统根据流程时限自动发送催办提醒给审批人，财务人员也可手动发起催办；关键节点自动通知申请人，信息及时触达，推动流程高效流转。'
                        },
                        {
                            title: '数据看板与管理后台',
                            text: '财务人员和管理员可查看流程处理效率、咨询热点、待办任务等数据，支持批量通知、流程干预，持续优化财务运营。'
                        }
                    ],
                    card: [
                        {
                            title: '员工报销咨询',
                            text: '员工提问“差旅费报销标准”，AI立即给出政策摘要和附件指引，无需等待财务回复。',
                        },
                        {
                            title: '进度自助查询',
                            text: '员工输入“我的报销单到哪了”，系统展示当前审批节点和预计时间，心中有数。',
                        },
                        {
                            title: '财务催办任务',
                            text: '财务人员在后台一键催办超时审批，系统自动发送提醒给审批人，减少人工跟进。',
                        },
                        {
                            title: '批量通知发布',
                            text: '财务通过助手发布公积金基数调整通知，全员或指定部门即时收到，确保信息传达。',
                        },
                        {
                            title: '预算余额查询',
                            text: '部门负责人查询本部门预算使用情况，辅助支出决策，避免超支。',
                        },
                        {
                            title: '新员工入职指引',
                            text: '新员工咨询“如何办理工资卡”，助手提供流程和材料清单，快速融入。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '提升员工体验',
                            titleb: '',
                            text: '7×24小时自助服务，告别“等回复”，财务问题随时解决。'
                        },
                        {
                            title: '降低沟通成本',
                            titleb: '',
                            text: '减少重复咨询和催促，释放财务人力投入高价值工作。'
                        }, {
                            title: '流程透明高效',
                            titleb: '',
                            text: '进度实时可见，催办自动化，审批效率大幅提升。'
                        }, {
                            title: '数据驱动管理',
                            titleb: '',
                            text: '沉淀财务咨询与流程数据，持续优化服务与政策。'
                        }, {
                            title: '安全可控',
                            titleb: '',
                            text: '权限分级管理，确保敏感信息仅对授权人员开放。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs6.png'),
                        // require('@/assets/AI/gnzs7.png'),
                        // require('@/assets/AI/gnzs8.png')
                    ],
                    gnzsb: [
                        {
                            title: 'AI智能体财务助手',
                            img: require('@/assets/AI/gnzs6.png'),
                            width: 'auto',
                        }, {
                            title: '智能体会话',
                            img: require('@/assets/AI/gnzs7.png'),
                            width: 'auto',
                        }, {
                            title: '智能业务流程',
                            img: require('@/assets/AI/gnzs8.png'),
                            width: 'auto',
                        }
                    ]
                },
                {
                    title: 'AI知识库',
                    text: '多源数据接入+智能语义理解，构建企业级知识中枢',
                    info: '将分散在产品说明书、技术文档、FAQ等资料中的知识，通过智能解析与向量化技术，统一构建成可被AI调用的知识库，为业务应用提供高质量数据源，让知识从“存起来”到“用起来”。',
                    img: require('@/assets/AI/cp-ai-4.jpg'),
                    hxgn: [
                        {
                            title: '多源异构数据接入',
                            text: '支持批量导入多种格式文档（PDF、Word、PPT、Excel等），同时提供API、数据库直连、网页抓取等方式，快速汇聚分散数据，打破系统孤岛，为知识库建设奠定基础。'
                        },
                        {
                            title: '智能文档处理与解析',
                            text: '精准解析复杂排版文件（如带表格、多栏的PDF），解决长文档结构混乱问题，自动清洗冗余内容，提取核心文本、图表信息，确保知识干净可用。'
                        },
                        {
                            title: '智能分块与向量化',
                            text: '突破大模型上下文窗口限制，通过智能分块算法将文档切分为语义完整的片段，并转化为向量数据，使知识库从字面匹配升级为语义理解。'
                        },
                        {
                            title: '混合检索与召回',
                            text: '结合向量检索与关键词检索，快速召回相似片段，并通过重排序剔除低相关性内容，将最匹配的片段输入大模型，显著提升问答准确性和用户体验。'
                        }
                    ],
                    card: [
                        {
                            title: '研发知识协同',
                            text: '研发团队分散多地，技术文档版本混乱。AI知识库统一管理产品文档、技术方案，支持语义搜索，快速复用历史方案，提升协作效率。',
                        },
                        {
                            title: '客服智能问答',
                            text: '客服人员面对客户复杂问题，可在知识库中快速获取标准答案，或通过AI助手自动回复，提高问题解决率和响应速度。',
                        },
                        {
                            title: '合规审计辅助',
                            text: '财务、法务等岗位需频繁查阅合规文档。知识库自动抓取最新政策法规，支持自然语言查询，确保业务操作合规，降低审计风险。',
                        },
                        {
                            title: '员工自助问答',
                            text: '新员工入职可通过知识库自助查询制度、流程、常见问题，减少对HR、IT的重复咨询，快速上手工作。',
                        },
                        {
                            title: '销售赋能',
                            text: '销售人员在客户现场可随时查询产品参数、案例、竞品对比，生成定制方案，提升成单率。',
                        },
                        {
                            title: '员工培训',
                            text: '将培训资料、操作手册纳入知识库，新员工随时学习，老员工快速回顾，降低培训成本。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '激活数据资产',
                            titleb: '',
                            text: '将分散的文档、资料转化为可检索、可利用的知识资产，释放企业隐性知识。'
                        },
                        {
                            title: '提升检索效率',
                            titleb: '',
                            text: '语义理解替代关键词匹配，让员工快速找到所需信息，减少无效查找时间。'
                        }, {
                            title: '支撑AI应用',
                            titleb: '',
                            text: '为智能客服、问答机器人、业务助手等提供高质量知识源，提升AI回答准确性。'
                        }, {
                            title: '降低管理成本',
                            titleb: '',
                            text: '自动化清洗、分块、向量化，减少人工整理投入，知识更新更及时。'
                        }, {
                            title: '安全可控',
                            titleb: '',
                            text: '权限分级管理，确保敏感知识仅对授权人员开放。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs9.png'),
                        require('@/assets/AI/gnzs10.png')
                    ]
                },
                {
                    title: 'AI智能客服',
                    text: '生成式AI + 全渠道对话引擎，让每一次服务都更智能、更温暖',
                    info: '基于大模型构建的智能客服系统，支持多轮对话、复杂语义理解与情绪识别，可自动生成个性化解决方案并联动业务系统（如自动创建工单、查询订单），覆盖产品咨询、售后处理、销售挖掘等场景，问题解决率提升至89%。',
                    img: require('@/assets/AI/cp-ai-5.jpg'),
                    hxgn: [
                        {
                            title: '可视化流程编排',
                            text: '支持通过可视化拖拉拽方式编排原子能力，快速搭建复杂对话流程，覆盖产品咨询、订单寄送、信息查询等40余类任务，显著节省人工座席工作量，提升服务效率。'
                        },
                        {
                            title: '多轮意图收集',
                            text: '通过多轮对话主动收集客户意图，如故障描述、产品型号、购买意向等，精准定位客户需求，为后续流程化处理提供完整信息。'
                        },
                        {
                            title: '大模型+代码节点',
                            text: '集成大模型节点，支持复杂语义理解和生成式回复；同时提供代码节点，可执行定制化逻辑（如价格计算、库存校验），满足个性化业务场景。'
                        },
                        {
                            title: '业务系统联动',
                            text: '与CRM、ERP、工单系统无缝集成，识别客户意图后自动触发业务动作：创建售后工单、查询物流状态、推送优惠券、转接人工专家等，实现服务闭环。'
                        },
                        {
                            title: '情绪识别与分级应对',
                            text: '实时检测客户语音语调、文字关键词，识别愤怒、焦虑等负面情绪，自动调整回复策略，比如发送安抚话术或进度通知；严重冲突秒转人工专家，并推送客户画像和历史记录，助力快速平息投诉。'
                        }
                    ],
                    card: [
                        {
                            title: '产品咨询与推荐',
                            text: '客户询问“适合办公室的咖啡机”，AI根据需求推荐型号、对比功能，并推送购买链接，同时记录意向。',
                        },
                        {
                            title: '售后故障报修',
                            text: '客户上传设备故障视频，AI自动诊断问题，生成图文版排查指南，如需维修则一键创建工单，预约工程师。',
                        },
                        {
                            title: '订单物流查询',
                            text: '客户输入“我的订单到哪了”，AI实时查询物流状态，主动推送最新进度，并提醒签收注意事项。',
                        },
                        {
                            title: '销售机会挖掘',
                            text: '识别客户咨询中的比价、扩容等信号，自动标记高意向对话，生成客户画像并推送销售部门跟进。',
                        },
                        {
                            title: '投诉与情绪安抚',
                            text: '检测到客户情绪激动，AI自动降低语速、表达歉意，并升级至人工专家，同时推送客户历史交互记录，助力快速解决。',
                        },
                        {
                            title: '多轮信息收集',
                            text: '在办理退换货流程中，通过多轮对话收集订单号、退货原因、照片凭证，自动生成退换货申请，减少人工录入。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '提升服务效率',
                            titleb: '',
                            text: '7×24小时秒级响应，自动处理80%常规咨询，人工聚焦复杂问题。'
                        },
                        {
                            title: '优化客户体验',
                            titleb: '',
                            text: '精准理解客户意图，个性化回复，情绪识别让服务更有温度。'
                        }, {
                            title: '降低运营成本',
                            titleb: '',
                            text: '减少人工座席投入，缩短培训周期，可视化编排降低运维门槛。'
                        }, {
                            title: '挖掘销售机会',
                            titleb: '',
                            text: '自动识别购买信号，推送销售线索，助力业绩增长。'
                        }, {
                            title: '数据驱动优化',
                            titleb: '',
                            text: '沉淀对话数据，分析热点问题，持续优化知识库和业务流程。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs11.png'),
                        require('@/assets/AI/gnzs12.png'),
                        require('@/assets/AI/gnzs13.png')
                    ]
                },
                {
                    title: '智能安防AI预警',
                    text: '无人机巡检 + AI图像识别，构建主动防御新范式',
                    info: '告别人工盯防与滞后响应，让AI实时发现人员违规、物品隐患、环境异常，第一时间推送至责任人，形成“发现-处置-归档”完整闭环，全面提升园区安全等级。',
                    img: require('@/assets/AI/cp-ai-1.jpg'),
                    hxgn: [
                        {
                            title: '全场景智能识别',
                            text: 'AI实时分析无人机批量照片，精准识别人员违规（翻墙、入侵、违规作业）、物品隐患（遗留物、违停、设备异常）和环境风险（烟火、积水、扬尘），识别准确率≥95%。'
                        },
                        {
                            title: '无人机自动巡检',
                            text: '支持自定义航线与重点区域（围墙、危化品库），无人机定时或事件触发巡检，画面实时回传；支持存量照片批量上传审核，快速追溯历史风险。'
                        },
                        {
                            title: '企业微信实时预警',
                            text: '识别风险后，系统通过企业微信秒级推送预警，包含风险类型、位置截图、处置建议。支持分级推送、群组提醒、@指定人员，并可配置不同风险等级的通知策略，确保责任人第一时间响应。'
                        },
                        {
                            title: '闭环处置流程',
                            text: '责任人接收预警后可在企业微信确认、转派任务；现场处置上传照片、填写结果，系统自动记录进度。超时未处理自动督办，形成“接收—处置—反馈—归档”完整闭环。'
                        }
                    ],
                    card: [
                        {
                            title: '园区周界',
                            text: '实时识别翻墙、攀爬、靠近警戒线等行为，夜间配合热成像，杜绝非法入侵。',
                        },
                        {
                            title: '危化品仓库',
                            text: '监测烟火、人员违规闯入、设备过热，提前预防重大事故。',
                        },
                        {
                            title: '施工现场',
                            text: '识别未戴安全帽、违规作业、材料乱堆放，保障人员与设施安全。',
                        },
                        {
                            title: '设备巡检',
                            text: '无人机定期巡检电力设施、管道、光伏板，AI自动发现锈蚀、破损、异物附着。',
                        },
                        {
                            title: '大型活动',
                            text: '实时监测人群密度、异常奔跑、聚集斗殴，辅助现场指挥快速调度。',
                        },
                        {
                            title: '环境监测',
                            text: '识别露天焚烧、扬尘、积水，及时预警环境污染与内涝风险。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '预防为主',
                            titleb: '主动发现',
                            text: 'AI 7×24小时不间断巡检，将风险消灭在萌芽状态，大幅降低安全事故发生率。'
                        },
                        {
                            title: '流程闭环',
                            titleb: '责任到人',
                            text: '预警、处置、反馈全程线上化，责任清晰，处置效率显著提升。'
                        }, {
                            title: '数据驱动',
                            titleb: '持续优化',
                            text: '沉淀安全数据资产，通过趋势分析不断优化安防策略，让管理更科学。'
                        }, {
                            title: '轻量部署',
                            titleb: '快速见效',
                            text: '与企业微信无缝集成，无需更换现有监控设备，即可快速上线使用。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs1.png'),
                        require('@/assets/AI/gnzs2.png'),
                        require('@/assets/AI/gnzs3.png')
                    ]
                },
                {
                    title: '智能运维接管',
                    text: 'AI知识库 + 智能分流引擎，让设备报修从此“不绕路”',
                    info: '将报修知识文档提前接入AI知识库，员工报修时，AI自动分析故障描述，精准判断问题类型——软件问题直接派单给IT人员，硬件问题先提供自助排查建议再通知维修人员。报修人可根据建议自助解决并一键确认，大幅缩短处理周期，让运维流程更顺畅。',
                    img: require('@/assets/AI/智能运维.jpg'),
                    hxgn: [
                        {
                            title: '智能报修分析',
                            text: '员工提交报修时，AI基于报修描述（文字/图片/语音转文字），结合知识库中的故障案例、设备手册，自动识别问题类型、紧急程度和可能原因。'
                        },
                        {
                            title: '自动分流与派单',
                            text: '根据分析结果自动分流：软件问题（如系统卡顿、应用报错）直接生成工单，推送至对应IT人员；硬件问题（如设备无法开机、零件损坏）先生成自助排查建议，推送给报修人尝试解决，若未解决再派单给维修人员。'
                        },
                        {
                            title: '知识库辅助建议',
                            text: '提前将设备说明书、常见故障库、维修手册等文档接入AI知识库，报修时AI自动匹配相似案例，生成图文并茂的排查指南和操作建议，供报修人自助尝试。'
                        },
                        {
                            title: '闭环处置与确认',
                            text: '报修人可根据AI建议自助解决问题后，一键点击“已解决”，流程自动归档；若问题未解决，维修人员接单后可在工单中查看AI预分析结果和报修人尝试记录，快速定位问题，完成后报修人确认闭环。'
                        }
                    ],
                    card: [
                        {
                            title: '办公电脑报修',
                            text: '员工提交“电脑蓝屏，代码0x0000f”，AI识别为软件问题，自动推送IT人员远程修复，并附带常见解决方案。',
                        },
                        {
                            title: '会议室设备故障',
                            text: '会议室投影无法连接，AI分析可能是线缆松动或信号源设置问题，推送自助排查步骤，员工按指引操作后解决，无需等待IT。',
                        },
                        {
                            title: '打印机/复印机问题',
                            text: '打印机卡纸，AI根据描述推送卡纸清除视频和步骤，员工自助清理后点击确认，工单自动关闭。',
                        },
                        {
                            title: '网络故障报修',
                            text: '员工反馈“办公室WiFi无法连接”，AI判断可能是AP故障或认证问题，先推送重启AP建议，若无效则派单给网络工程师。',
                        },
                        {
                            title: '门禁/安防设备报修',
                            text: '门禁刷卡无反应，AI提示检查电源和网络连接，若仍无法解决则生成工单派给弱电维修人员，附带设备位置和故障日志。',
                        },
                        {
                            title: '服务器/机房告警',
                            text: '机房温度告警，AI自动关联空调设备状态，推送可能原因（空调故障、滤网堵塞），并通知运维人员处理。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '响应速度大幅提升',
                            titleb: '',
                            text: 'AI秒级分析，无需人工沟通，问题即时报、即刻分流。'
                        },
                        {
                            title: '减轻运维负担',
                            titleb: '',
                            text: '常见问题自助解决，运维人员从琐碎咨询中解放，专注复杂故障。'
                        }, {
                            title: '知识沉淀复用',
                            titleb: '',
                            text: '每次报修与解决过程自动归档，持续丰富知识库，越用越聪明。'
                        }, {
                            title: '流程透明闭环',
                            titleb: '',
                            text: '报修人实时掌握进度，解决后一键确认，信息同步无遗漏。'
                        }, {
                            title: '降低运营成本',
                            titleb: '',
                            text: '减少无效派单和重复沟通，整体维修效率提升，设备停机时间缩短。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs14.png'),
                        // require('@/assets/AI/gnzs15.png')
                    ], gnzsb: [{
                        title: 'AI识别硬件问题',
                        img: require('@/assets/AI/AI识别硬件问题.jpg'),
                        width: 'auto'
                    },{
                        title: 'AI识别软件问题',
                        img: require('@/assets/AI/AI识别软件问题.jpg'),
                        width: 'auto'
                    }, {
                        title: '智能体对话流程配置',
                        img: require('@/assets/AI/智能体对话流程配置.png'),
                        width: 'auto'
                    }
                    ]
                },
                {
                    title: '网络日志智能报表',
                    text: 'RPA + AI 自动采集分析，让安全报告从“人工整理”到“智能生成”',
                    info: '通过RPA机器人自动采集网络、算力、安全等多源日志，AI深度分析后生成结构化信息安全月报，清晰标注高、中、低风险等级，帮助安全团队快速掌握整体态势，及时应对隐患，大幅提升日志分析效率。',
                    img: require('@/assets/AI/网络日志.jpg'),
                    hxgn: [
                        {
                            title: 'RPA自动日志采集',
                            text: '通过RPA机器人定时从网络设备、服务器、安全设备（防火墙、IDS等）自动导出日志，支持多格式（syslog、文本、CSV），统一存放至指定目录，实现无人值守的全量采集。'
                        },
                        {
                            title: 'AI智能分析',
                            text: 'AI对日志数据进行深度解析，通过NLP提取关键字段（时间、IP、事件类型、威胁指标），识别异常登录、暴力破解、恶意流量等安全事件，并聚类分析高频风险。'
                        },
                        {
                            title: '风险等级评估',
                            text: '基于内置威胁情报和规则库，AI将每起安全事件划分为高危、中危、低危等级。高危项自动触发额外标记和摘要说明，确保重点关注。'
                        },
                        {
                            title: '报表自动生成与分发',
                            text: '根据预设模板（日报/周报/月报），AI自动生成结构化报告，包含风险总览、等级分布、趋势图表、TOP事件清单，支持PDF/Excel/Word导出，并可自动推送至企业微信、邮件或安全管理员。'
                        }
                    ],
                    card: [
                        {
                            title: '信息安全月报生成',
                            text: '每月初，RPA自动采集上月全量日志，AI分析后生成包含高危事件统计、攻击来源分布、漏洞趋势的完整月报，安全负责人可快速掌握整体安全状况。',
                        },
                        {
                            title: '合规审计报告',
                            text: '等保、ISO27001等合规检查前，系统自动生成合规所需的日志审计报告，涵盖日志留存情况、异常行为记录、处置记录，大幅节省迎检准备时间。',
                        },
                        {
                            title: '日常安全巡检',
                            text: '每日/每周自动生成安全巡检简报，列出新增高风险事件、未处置威胁、异常流量波动，帮助运维团队及时发现并处置隐患。',
                        },
                        {
                            title: '应急响应复盘',
                            text: '发生安全事件后，AI快速分析相关日志，生成事件时间线、攻击路径、受影响资产报告，支撑溯源分析和整改复盘。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '效率革命',
                            titleb: '',
                            text: '从数天的人工整理缩短至分钟级自动生成，释放安全团队精力。'
                        },
                        {
                            title: '降低漏报',
                            titleb: '',
                            text: 'AI 7×24小时不间断分析，不放过任何可疑行为，高危风险无处遁形。'
                        }, {
                            title: '标准规范',
                            titleb: '',
                            text: '报告格式统一、内容完整，满足内部管理和外部合规双重需求。'
                        }, {
                            title: '数据沉淀',
                            titleb: '',
                            text: '历史报告自动归档，支持趋势分析，安全策略优化有据可依。'
                        }, {
                            title: '轻量部署',
                            titleb: '',
                            text: 'RPA+AI方案与现有日志系统无缝集成，无需更换设备，即装即用。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs16.png'),
                        require('@/assets/AI/gnzs17.png'),
                        require('@/assets/AI/gnzs18.png')
                    ]
                },
                {
                    title: '招投标肋手',
                    text: 'AI解析+智能比对，让招投标审核从“逐页翻看”到“一键洞察”',
                    info: '上传招标文件，AI自动提取核心要求、资质条件、评分标准等关键信息，结构化呈现并智能提示风险条款；在投标评审环节，自动比对投标响应文件与招标要求，快速标出偏差项，为审核专家提供清晰参考，确保评审规范、完整、高效。',
                    img: require('@/assets/AI/招投标助手.jpg'),
                    hxgn: [
                        {
                            title: '智能招标解析',
                            text: '上传招标文件（PDF/Word），AI自动识别并提取关键信息：资质要求、技术参数、评分标准、付款方式、交付期限、违约责任等，以结构化表格呈现，支持一键导出，大幅减少人工翻阅时间。'
                        },
                        {
                            title: '风险条款提示',
                            text: '基于内置法规库和历史案例，AI分析招标文件中可能存在的风险条款，如不合理资质门槛、模糊的验收标准、单方面解约权等，并标注风险等级与建议，帮助审核人员在投标前规避潜在陷阱。'
                        },
                        {
                            title: '自动偏差比对',
                            text: '在投标评审环节，AI将投标响应文件与招标要求进行逐条语义比对，自动标记完全响应、部分响应、未响应及存在偏差的内容，生成比对报告，支持评审专家快速定位差异点，确保评审全面、客观。'
                        },
                        {
                            title: '标书辅助审核',
                            text: '结合招标解析结果与偏差比对，AI为标书编写者提供针对性建议（如“技术参数需补充证明材料”“资质文件缺失”），并生成检查清单；支持多人协同批注与版本管理，让标书审核流程更规范。'
                        }
                    ],
                    card: [
                        {
                            title: '招标文件预审',
                            text: '投标团队上传招标文件，AI自动提取关键要求和风险点，生成摘要报告，帮助团队快速决策是否参与投标，并明确重点准备方向。',
                        },
                        {
                            title: '投标方案编写',
                            text: '编写标书时，AI根据招标要求实时提示应响应的内容，并提供历史相似项目的应答范例，减少遗漏，提升响应质量。',
                        },
                        {
                            title: '投标前偏差检查',
                            text: '投标文件定稿前，AI自动与招标要求进行全量比对，输出偏差清单，提醒团队补充或修正，避免因细微偏差导致废标。',
                        },
                        {
                            title: '专家评审辅助',
                            text: '评审专家接收投标文件后，AI提前完成招标-投标比对，生成比对报告，专家可直接聚焦偏差项和重点内容，大幅缩短评审周期。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '效率倍增',
                            titleb: '',
                            text: '招标解析、风险识别、偏差比对全流程自动化，审核时间缩短70%以上。'
                        },
                        {
                            title: '降低风险',
                            titleb: '',
                            text: '提前发现招标文件中的隐患条款，避免中标后陷入被动；投标偏差提前修正，减少废标可能。'
                        }, {
                            title: '规范评审',
                            titleb: '',
                            text: '比对标准统一、结果可追溯，确保评审过程客观公正，满足合规要求。'
                        }, {
                            title: '知识沉淀',
                            titleb: '',
                            text: '历史招标与投标数据自动归档，形成企业知识库，新项目可快速复用经验。'
                        }, {
                            title: '协同提效',
                            titleb: '',
                            text: '支持团队在线协作、批注留痕，招投标流程更透明、可控。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs19.png'),
                        // require('@/assets/AI/gnzs20.png'),
                        // require('@/assets/AI/gnzs21.png')
                    ], gnzsb: [
                        { title: '定位异常内容', img: require('@/assets/AI/定位异常内容.png'), width: 'auto' },
                        { title: '识别异常', img: require('@/assets/AI/识别异常.png'), width: 'auto' },
                        { title: '文件解析回溯', img: require('@/assets/AI/文件解析回溯.png'), width: 'auto' },
                        { title: '智能业务流程', img: require('@/assets/AI/智能业务流程.png'), width: 'auto' }
                    ],
                },
                {
                    title: '施工技术方案智能审核平台',
                    text: 'AI学习行业规范 + 自动参数校验，让方案审查从“专家数日”到“智能分钟”',
                    info: 'AI深度解析国家、行业标准规范，对施工方案进行全方位智能评审，自动校验技术参数合规性、安全措施完整性，一键生成标准化评审报告，实现方案审查的数字化、高效化与精准化。',
                    img: require('@/assets/AI/施工技术方案智能审核平台.jpg'),
                    hxgn: [
                        {
                            title: '行业规范学习与知识库',
                            text: '系统内置国家、行业最新标准规范（建筑、市政、公路等），支持自定义上传企业标准。AI持续学习规范条文，构建结构化知识库，为智能审核提供权威依据。'
                        },
                        {
                            title: '技术参数自动校验',
                            text: '自动识别施工方案中的技术参数（如混凝土强度等级、钢筋间距、模板支撑体系尺寸），与规范要求逐项比对，生成合规性判定结果，精准标注超标或不足项。'
                        },
                        {
                            title: '安全措施完整性检查',
                            text: '基于规范对安全专项方案、应急预案、安全防护措施的要求，全面检查方案中是否包含必备的安全条款，识别缺失或不足，提示补充完善。'
                        },
                        {
                            title: '一键生成评审报告',
                            text: '审核完成后，系统自动生成结构化评审报告，包含总体结论、不符项清单、修改建议、规范依据原文。支持在线预览及PDF/Word下载，便于分发与存档。'
                        }
                    ],
                    card: [
                        {
                            title: '施工组织设计审核',
                            text: '总包单位上传施工组织设计，AI自动核对工期安排、资源配置、技术措施是否符合规范，快速输出审核意见。',
                        },
                        {
                            title: '专项施工方案审查',
                            text: '深基坑、高支模等危大工程专项方案，AI重点检查计算书参数、安全措施、监测要求，确保满足强制性条文。',
                        },
                        {
                            title: '变更方案复核',
                            text: '发生设计变更后，上传变更方案，AI快速复核新方案的技术参数和安全措施，评估合规风险。',
                        },
                        {
                            title: '现场交底准备',
                            text: '项目技术负责人准备现场交底时，通过AI提取方案中的关键控制点和安全注意事项，生成交底要点清单。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '效率革命',
                            titleb: '',
                            text: '方案审查从数日缩短至分钟级，专家精力聚焦复杂问题判断。'
                        },
                        {
                            title: '降低漏检',
                            titleb: '',
                            text: 'AI不知疲倦，逐条比对，确保所有技术参数和安全条款全覆盖。'
                        }, {
                            title: '标准统一',
                            titleb: '',
                            text: '基于同一规范库，审核尺度一致，避免不同专家判断差异。'
                        }, {
                            title: '知识沉淀',
                            titleb: '',
                            text: '每次审核结果自动归档，形成企业审查案例库，持续优化标准。'
                        }, {
                            title: '合规保障',
                            titleb: '',
                            text: '及时发现合规风险，避免因方案问题导致的质量安全事故。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs22.png'),
                        // require('@/assets/AI/gnzs23.png'),
                        // require('@/assets/AI/gnzs24.png')
                    ], gnzsb: [
                        { title: '技术方案审核解析', img: require('@/assets/AI/技术方案审核解析.png'), width: 'auto' },
                        { title: '审核异常追溯', img: require('@/assets/AI/审核异常追溯.png'), width: 'auto' },
                        { title: '智能业务流程', img: require('@/assets/AI/智能业务流程b.png'), width: 'auto' }
                    ]
                }
            ],
            data: {},
            height: 'calc(100vh - 80px)',

        }
    },
    created() {
        var w = window.innerWidth
        var h = window.innerHeight * 0.18 + window.innerHeight - 80
        if (w < 1550) {
            this.height = h + 'px'
        }
        this.load()
    },
    activated() {
        this.load()
    },
    methods: {
        load() {
            var title = this.$route.query.title || this.$route.query.id
            if (title) {
                this.menu.forEach(x => {
                    if (x.title == title) {
                        this.getInfo(x)
                    }
                })
            } else {
                this.getInfo(this.menu[0], 0)
            }
            ul = document.getElementById('scrollcontainer');
            ul.addEventListener('mousedown', (e) => {
                isMouseDown = true;
            })
            ul.addEventListener('mousemove', (e) => {
                if (isMouseDown) {
                    ul.scrollBy(-e.movementX, 0);
                }
            })
            ul.addEventListener('mouseup', (e) => {
                isMouseDown = false;
            })
            ul.addEventListener('mouseleave', (e) => {
                isMouseDown = false;
            })
        },
        getInfo(w, j) {
            ul = document.getElementById('scrollcontainer');
            this.index = j
            this.mindex = w.title
            this.data = w
        }
    },
}
</script>
<style scoped>
.mindex {
    font-size: 22px !important;
    font-weight: bold !important;
    background: #fff !important;
    color: #333 !important;
}

.menu:hover {
    background: #fff;
    color: #333 !important;
}

.scroll-container::-webkit-scrollbar {
    /* WebKit */
    display: none;
}

/* .cardx:last-child{
    margin-right: auto;
    margin-left: 60px;
} */
/* .flex-container::after {
            content: "";
            flex: auto;
        } */
</style>